var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BaseCell,{attrs:{"align":_vm.align}},[(!_setup.risk)?_c('span',[_vm._v("-")]):_c('span',{staticClass:"risk-chip"},[_c('div',{staticClass:"risk-chip__bullet",style:(_setup.bulletStyle)}),_vm._v(" "+_vm._s(_setup.risk.formatted)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }